import { isFulfilled, isPending, isRejected } from "../../utils/redux/action-utils.js";
import { onFulfilled, onPending, onRejected } from "../../utils/redux/state-utils.js";
//#region src/redux/i18n/extra-reducers.ts
var isActionFulfilled = (action) => isFulfilled(action, "i18n");
var isActionPending = (action) => isPending(action, "i18n");
var isActionRejected = (action) => isRejected(action, "i18n");
var extraReducers = (builder) => {
	builder.addMatcher(isActionFulfilled, onFulfilled).addMatcher(isActionPending, onPending).addMatcher(isActionRejected, onRejected);
};
//#endregion
export { extraReducers };

//# sourceMappingURL=extra-reducers.js.map